import script from "./Cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cards.vue?vue&type=script&setup=true&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=a60f17fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a60f17fe"]])

export default __exports__